import { Controller } from '@hotwired/stimulus';

// 明細一括送信の案内モーダル (#3119)。開いたボタンによって見出しを変える。
// 支給日の変更ボタンからも同じモーダルを開くため、どちらから来たかで文言を
// 出し分ける。
//
// controller はモーダルを開くボタン側に付ける。モーダル (#sendModalAll) は
// ページ末尾にあり、ボタンとは DOM 上で離れているため target では届かない。
export default class extends Controller {
  static values = { title: String, modal: String };

  setTitle() {
    const modal = document.querySelector(this.modalValue);
    if (!modal) return;

    const title = modal.querySelector('.modal-title');
    if (title) title.textContent = this.titleValue;
  }
}
